// export default interface ExcelColumnDataInterface {
//   label: string;
//   field: string;
// }

// Formato com export-excel
// const ExcelColumnsDataInitialValue: any = {
//   id: 'id',
//   fundId: 'fundId',
//   title: 'title',
//   description: 'description',
//   summary: 'summary',
//   fees: 'fees',
//   created: 'created',
//   targetFundSize: 'targetFundSize',
//   minimalInvestment: 'minimalInvestment',
//   maturity: 'maturity',
//   deadline: 'deadline',
//   domicile: 'domicile',
//   unity: 'unity',
//   area: 'area',
//   status: 'status',
//   shareClass: 'shareClass',
//   targetIrr: 'targetIrr',
//   targetDividend: 'targetDividend',
//   investmentVehicle: 'investmentVehicle',
//   targetSize: 'targetSize',
//   targetYield: 'targetYield',
//   expectedTerm: 'expectedTerm',
//   strategyAUM: 'strategyAUM',
//   ytdPerformance: 'ytdPerformance',
//   lastMonthPerformance: 'lastMonthPerformance',
//   raised: 'raised',
//   irr: 'irr',
//   cashYield: 'cashYield',
//   size: 'size',
//   investorType: 'investorType',
//   published: 'published',
//   returnSinceInception: 'returnSinceInception',
//   aum: 'aum',
//   inceptionDate: 'inceptionDate',
//   committedCapital: 'committedCapital',
// };

// Formato com vue-excel-xlsx
const ExcelColumnsDataInitialValue: any = [
  {
    label: 'id',
    field: 'id',
  },
  {
    label: 'fundId',
    field: 'fundId',
  },
  {
    label: 'title',
    field: 'title',
  },
  {
    label: 'description',
    field: 'description',
  },
  {
    label: 'summary',
    field: 'summary',
  },
  {
    label: 'fees',
    field: 'fees',
  },
  {
    label: 'created',
    field: 'created',
  },
  {
    label: 'targetFundSize',
    field: 'targetFundSize',
  },
  {
    label: 'minimalInvestment',
    field: 'minimalInvestment',
  },
  {
    label: 'maturity',
    field: 'maturity',
  },
  {
    label: 'deadline',
    field: 'deadline',
  },
  {
    label: 'domicile',
    field: 'domicile',
  },
  {
    label: 'unity',
    field: 'unity',
  },
  {
    label: 'area',
    field: 'area',
  },
  {
    label: 'status',
    field: 'status',
  },
  {
    label: 'shareClass',
    field: 'shareClass',
  },
  {
    label: 'targetIrr',
    field: 'targetIrr',
  },
  {
    label: 'targetDividend',
    field: 'targetDividend',
  },
  {
    label: 'investmentVehicle',
    field: 'investmentVehicle',
  },
  {
    label: 'targetSize',
    field: 'targetSize',
  },
  {
    label: 'targetYield',
    field: 'targetYield',
  },
  {
    label: 'expectedTerm',
    field: 'expectedTerm',
  },
  {
    label: 'strategyAUM',
    field: 'strategyAUM',
  },
  {
    label: 'ytdPerformance',
    field: 'ytdPerformance',
  },
  {
    label: 'lastMonthPerformance',
    field: 'lastMonthPerformance',
  },
  {
    label: 'raised',
    field: 'raised',
  },
  {
    label: 'irr',
    field: 'irr',
  },
  {
    label: 'cashYield',
    field: 'cashYield',
  },
  {
    label: 'size',
    field: 'size',
  },
  {
    label: 'investorType',
    field: 'investorType',
  },
  {
    label: 'published',
    field: 'published',
  },
  {
    label: 'returnSinceInception',
    field: 'returnSinceInception',
  },
  {
    label: 'aum',
    field: 'aum',
  },
  {
    label: 'inceptionDate',
    field: 'inceptionDate',
  },
  {
    label: 'committedCapital',
    field: 'committedCapital',
  },
];

export { ExcelColumnsDataInitialValue };
